import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=5c84b168&"
import script from "./GlobalDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalDialog.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDialog.vue?vue&type=style&index=0&id=5c84b168&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports